import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KnowledgebaseService {

  
  private searchQuerySubject: BehaviorSubject<{ query: string, selectedDepartment: any, selectedCategory: any }> = new BehaviorSubject({ query: '', selectedDepartment: '', selectedCategory: '' });
  searchQuery$: Observable<{ query: string, selectedDepartment: any, selectedCategory: any }> = this.searchQuerySubject.asObservable();

  updateSearchQuery(query: string, selectedDepartment: string, selectedCategory: string): void {
  this.searchQuerySubject.next({ query, selectedDepartment, selectedCategory });
  }
  private searchEventSource = new Subject<void>();

  searchEvent$ = this.searchEventSource.asObservable();

  triggerSearchEvent() {
    this.searchEventSource.next();
  }

}
